import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BannerContainer, BannerContentWrapper, BannerImage, BannerWrapper } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/__internal__/styled";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { trackInsiderLoggedOutMarketingPageEarlyAccessBannerView } from "@faire/web-api--source/events/insider/view/loggedOutMarketingPageEarlyAccessBanner";
import * as React from "react";
import styled from "styled-components";
export var InsiderHighlightedBenefitBanner = function(param) {
    var imgSrc = param.imgSrc, title = param.title, description = param.description;
    var ref = useDoActionWhenVisible(function() {
        trackInsiderLoggedOutMarketingPageEarlyAccessBannerView();
    });
    return /*#__PURE__*/ _jsx(BannerWrapper, {
        ref: ref,
        children: /*#__PURE__*/ _jsxs(BannerContainer, {
            children: [
                /*#__PURE__*/ _jsx(BannerImage, {
                    src: imgSrc
                }),
                /*#__PURE__*/ _jsxs(BannerContentWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(StyledTypography, {
                            variant: "displaySSerifRegular",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "2x"
                        }),
                        /*#__PURE__*/ _jsx(StyledTypography, {
                            variant: {
                                mobileAndAbove: "paragraphSansRegular",
                                desktopAndAbove: "subheadingSansRegular"
                            },
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
var StyledTypography = styled(Typography).withConfig({
    componentId: "sc-ae29d20f-0"
})([
    "max-width:300px;",
    "{max-width:320px;}",
    "{max-width:467px;}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
